import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getLayerLabel, type LayerId } from '../data/layerOrder';
import type { SlideLayout } from '../data/slides';

export const useLayerLabel = () => {
  const { t } = useTranslation();

  return useCallback(
    (layout: SlideLayout, layerId: LayerId) => getLayerLabel(layout, layerId, t),
    [t],
  );
};
